<script>
    // import {slide} from 'svelte/transition';
    import R, {LOADER} from "../lib/requests";
    // import {accordion} from "../lib/accordion";
    import {clickOutside} from '../lib/clickOutside.js';
    import {createEventDispatcher} from 'svelte/internal';
    import {setFocusTo} from "../lib/lib";
    import InputAutosize from "../components/controls/InputAutosize.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import Alert from "../stores/alerts";
    import ProjectSelectControl from "../components/controls/ProjectSelectControl.svelte";

    export let todo;

    let editTitle = false;
    let showMore = false;
    let statusChanged = false;
    let showDropdown = false;

    const dispatch = createEventDispatcher();

    const load = () => {
        const onSuccess = result => {
            todo.content = result.content;
            todo.project_id = result.project_id;
            todo.project = result.project;
        }

        const onFailure = err => {
        };

        R.handle(R.todo.details, todo.id, onSuccess, onFailure, LOADER.NONE);
    }

    const save = () => {
        const onSuccess = result => {
            todo.title = result.title;
            todo.view_index = result.view_index;
            if (statusChanged) {
                remove('status');
            } else {
                dispatch('change', todo);
            }
        }

        const onFailure = err => {
        };

        todo.title = todo.title.trim();
        if (!todo.title) {
            return;
        }

        R.handle(R.todo.edit, todo, onSuccess, onFailure, LOADER.NONE);
    }

    const onDelete = () => {
        Alert.delete("Διαγραφή εργασίας", `Να διαγραφεί η εργασία "${todo.title}";`, deleteTodo);
    }

    const deleteTodo = id => {
        const onSuccess = result => {
            remove('delete');
        }

        const onFailure = err => {
        };

        R.handle(R.todo.delete, todo.id, onSuccess, onFailure, LOADER.POPUP);
    }


    const onTitleEdit = () => {
        editTitle = true;
        dispatch('edit', todo.id);
        setFocusTo(`todoTitle-${todo.id}`);
    }

    const onTitleFocusout = () => {
        editTitle = false;
        dispatch('edit', null);
    }

    const onContentFocusIn = () => {
        console.log("onContentFocusIn");
        dispatch('edit', todo.id);
    }

    const onContentFocusOut = () => {
        console.log("onContentFocusOut");
        dispatch('edit', null);
    }


    const toggleContent = () => {
        showMore = !showMore;
        if (showMore) {
            if (todo.content === undefined) {
                load();
            }
        } else {
            delete (todo.content);
            delete (todo.project);
            delete (todo.project_id);
        }
    }

    const onToggleStatus = () => {
        todo.status = todo.status == 0 ? 1 : 0;
        statusChanged = true;
        save();
    }

    const remove = (action) => {
        let id = todo.id;
        let status = ~~todo.status;
        todo = null;
        statusChanged = false;
        dispatch('remove', {id, status, action});
    }


    const onClockingTask = () => {
        dispatch('clockingtask', todo);
    }

</script>
{#if todo}
    <!--    <div class="todo" out:slide="{{ duration: 100 }}">-->
    <div class="todo">
        <div class="todo-heading mb-1">
            <div class="status-icon" on:click={ onToggleStatus }
                 title="{ todo.status == 0 ? 'ολοκληρώθηκε' : 'επαναφορά' }">
                {#if todo.status == 1}
                    <AppIcon icon="check-circle" size="20" strokeWidth="2"/>
                {:else}
                    <AppIcon icon="circle" size="20" strokeWidth="2"/>
                {/if}
            </div>
            {#if !editTitle}
                <div class="title" on:click={ onTitleEdit }>
                    { todo.title }
                </div>
            {:else}
                <div class="title-input mb-2">
                    <InputAutosize css="form-control form-control-sm " id="todoTitle-{todo.id}"
                                   bind:value="{ todo.title }"
                                   on:change={ save }
                                   on:focusout={ onTitleFocusout }
                                   placeholder="τίτλος εργασίας"/>
                </div>
            {/if}
            <div class="more dropdown-container" use:clickOutside on:click_outside="{ () => showDropdown = false }"
                 on:click={ () => showDropdown = !showDropdown }>
                <AppIcon icon="more-vertical" size="18"/>
                {#if showDropdown}
                    <ul class="dropdown right">
                        <li class="dropdown-item d-flex align-items-center justify-content-between"
                            on:click={ onClockingTask }>
                            Χρονομέτρηση
                            <AppIcon icon="clock" cssClass="ms-1 me-0"/>
                        </li>
                        <li class="dropdown-item d-flex align-items-center justify-content-between"
                            on:click={ onDelete }>
                            Διαγραφή
                            <AppIcon icon="trash" cssClass="ms-1 me-0"/>
                        </li>
                    </ul>
                {/if}
            </div>
        </div>
        <div class="todo-more">
            {#if showMore}
                {#if todo.content != null}
                    <InputAutosize css="form-control content-input mt-2" id="todoContent-{todo.id}"
                                   bind:value="{ todo.content }"
                                   allowNewLine
                                   on:change={ save }
                                   on:focusin={ onContentFocusIn }
                                   on:focusout={ onContentFocusOut }
                                   placeholder="περισσότερα"/>


                    <div class="mt-2">
                        <ProjectSelectControl bind:projectId={ todo.project_id} project="{ todo.project }"
                                              on:focusin={ onContentFocusIn }
                                              on:focusout={ onContentFocusOut }
                                              on:change={ save } sm placeholder="project"/>
                    </div>
                {/if}
            {/if}

        </div>
        <button class="btn btn-link btn-block p-0" on:click={ toggleContent }>
            <AppIcon icon="{ !showMore ? 'more-horizontal' : 'chevron-up' }" size="18" strokeWidth="2"/>
        </button>
        {#if todo.status == 0 && todo.weeks_passed > 0}
            <div class="small text-center mt-1" class:text-gray={ todo.weeks_passed <= 1 }
                 class:text-danger={ todo.weeks_passed > 1 }>πριν { todo.weeks_passed } εβδομάδες
            </div>
        {/if}
        <div class="drag-drop-button">↕</div>
    </div>
{/if}

<style>
    .todo {
        position: relative;
        padding-left: 15px;
    }

    .todo .todo-heading {
        display: flex;
    }

    .todo .todo-heading .status-icon {
        width: 20px;
        height: 20px;
        color: #9d9d9d;
        border-radius: 50%;
        cursor: pointer;
        margin-top: 1px;
        margin-right: 5px;
    }

    .todo .todo-heading .status-icon:hover {
        color: #fff;
        background: #7367f0;
    }

    .todo .todo-heading .more {
        height: max-content;
        padding: 0 5px 5px 5px;
        margin-left: 5px;
        cursor: pointer;
    }

    .todo .todo-more {
        position: relative;
        padding-right: 15px;
    }

    .todo .drag-drop-button {
        position: absolute;
        display: flex;
        align-items: center;
        left: 0;
        top: 0;
        bottom: 0;
        font-size: 1.2rem;
        padding: 0 2px;
        cursor: grab;
        opacity: 0;
        transition: all .2s ease-in-out;
    }

    .todo:hover .drag-drop-button {
        opacity: 0.5;
    }

    .todo .title {
        font-weight: 500;
        width: calc(100% - 25px - 27px);
        cursor: pointer;
        /*background: #efefef;*/
    }

    .todo .title-input {
        width: calc(100% - 25px - 27px);
    }

    :global(.todo .content-input) {
        font-size: 14px;
        padding: 5px;
        border: none;
        background: #f5f5f5;
    }
</style>